(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-hero-3d"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.customElements && window.customElements.get('es-hero3d')) return;

  var THREE_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var GSAP_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';

  function loadOnce(src) {
    return new Promise(function (resolve) {
      var ex = document.querySelector('script[data-es-lib="' + src + '"]');
      if (ex) {
        if (ex.dataset.loaded === '1') return resolve();
        ex.addEventListener('load', function () { resolve(); });
        ex.addEventListener('error', function () { resolve(); });
        return;
      }
      var s = document.createElement('script');
      s.src = src; s.async = true; s.dataset.esLib = src;
      s.addEventListener('load', function () { s.dataset.loaded = '1'; resolve(); });
      s.addEventListener('error', function () { resolve(); });
      document.head.appendChild(s);
    });
  }

  function hexToRgb(hex) {
    hex = (hex || '').trim().replace('#', '');
    if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
    var n = parseInt(hex, 16);
    if (isNaN(n)) return [0, 0, 0];
    return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255];
  }

  var AURORA_VERT = [
    'attribute vec3 position;',
    'attribute vec2 uv;',
    'varying vec2 vUv;',
    'void main(){ vUv = uv; gl_Position = vec4(position.xy, 0.0, 1.0); }'
  ].join('\n');

  var AURORA_FRAG = [
    'precision highp float;',
    'varying vec2 vUv;',
    'uniform float uTime; uniform float uAspect; uniform vec2 uMouse;',
    'uniform vec3 uBg; uniform vec3 uMid; uniform vec3 uGlow1; uniform vec3 uGlow2;',
    'float hash(vec2 p){ return fract(sin(dot(p, vec2(127.1,311.7)))*43758.5453); }',
    'float noise(vec2 p){ vec2 i=floor(p), f=fract(p);',
    '  float a=hash(i), b=hash(i+vec2(1.,0.)), c=hash(i+vec2(0.,1.)), d=hash(i+vec2(1.,1.));',
    '  vec2 u=f*f*(3.-2.*f); return mix(mix(a,b,u.x),mix(c,d,u.x),u.y); }',
    'float fbm(vec2 p){ float v=0., a=0.5; for(int i=0;i<5;i++){ v+=a*noise(p); p*=2.02; a*=0.5; } return v; }',
    'void main(){',
    '  vec2 uv = vUv; uv.x *= uAspect;',
    '  vec2 q = uv * 2.2; float t = uTime * 0.05; vec2 m = uMouse * 0.25;',
    '  float n1 = fbm(q + vec2(t, t*0.6) + m);',
    '  float n2 = fbm(q*1.6 - vec2(t*0.7, t) + n1);',
    '  float n3 = fbm(q + n2 + m*1.5);',
    '  vec3 col = uBg;',
    '  col = mix(col, uMid, smoothstep(0.15, 0.85, n1));',
    '  col = mix(col, uGlow1, smoothstep(0.40, 0.98, n2) * 0.85);',
    '  col = mix(col, uGlow2, smoothstep(0.58, 1.0, n3) * 0.7);',
    '  float vig = smoothstep(1.35, 0.25, length((vUv-0.5)*vec2(uAspect,1.0)));',
    '  col *= 0.82 + 0.18*vig;',
    '  gl_FragColor = vec4(col, 1.0);',
    '}'
  ].join('\n');

  var PT_VERT = [
    'precision mediump float;',
    'attribute vec3 position; attribute float aDepth; attribute float aSize; attribute float aPhase;',
    'uniform float uTime; uniform vec2 uMouse;',
    'varying float vA;',
    'void main(){',
    '  vec3 p = position;',
    '  p.x += sin(uTime*0.12 + aPhase) * 0.03;',
    '  p.y += cos(uTime*0.09 + aPhase*1.3) * 0.03;',
    '  p.xy += uMouse * aDepth * 0.10;',
    '  gl_Position = vec4(p.xy, 0.0, 1.0);',
    '  gl_PointSize = aSize * (0.5 + aDepth);',
    '  vA = 0.12 + aDepth * 0.5;',
    '}'
  ].join('\n');

  var PT_FRAG = [
    'precision mediump float;',
    'uniform vec3 uTint; varying float vA;',
    'void main(){',
    '  vec2 d = gl_PointCoord - 0.5;',
    '  float a = smoothstep(0.5, 0.0, length(d));',
    '  gl_FragColor = vec4(uTint, a * vA);',
    '}'
  ].join('\n');

  class EsHero3D extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.es-hero3d__slide'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('.es-hero3d__dot'));
      this.canvas = this.querySelector('.es-hero3d__canvas');
      this.current = 0;
      this.mouse = { x: 0, y: 0, tx: 0, ty: 0 };
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = this.dataset.autoplay === 'true' && !this.reduced;
      this.speed = (parseFloat(this.dataset.speed) || 5) * 1000;

      this.bind();
      var self = this;
      Promise.all([loadOnce(THREE_SRC), this.reduced ? Promise.resolve() : loadOnce(GSAP_SRC)])
        .then(function () {
          self.gsap = window.gsap || null;
          if (!self.reduced) self.initThree();
          self.intro();
          self.observe();
          if (self.autoplay) self.play();
        });
    }

    disconnectedCallback() { this.cleanup(); }

    bind() {
      var self = this;
      this.onClick = function (e) {
        var dot = e.target.closest('.es-hero3d__dot');
        if (dot) { self.goTo(parseInt(dot.dataset.i, 10)); self.restart(); return; }
        var arrow = e.target.closest('.es-hero3d__arrow');
        if (arrow) { self.goTo(self.current + (arrow.dataset.dir === 'next' ? 1 : -1)); self.restart(); }
      };
      this.addEventListener('click', this.onClick);

      this.onEnter = function () { self.pause(); };
      this.onLeave = function () { self.mouse.tx = 0; self.mouse.ty = 0; if (self.autoplay) self.play(); };
      this.onMove = function (e) {
        var r = self.getBoundingClientRect();
        self.mouse.tx = ((e.clientX - r.left) / r.width) * 2 - 1;
        self.mouse.ty = ((e.clientY - r.top) / r.height) * 2 - 1;
        self.tiltFrame();
      };
      this.addEventListener('pointerenter', this.onEnter);
      this.addEventListener('pointerleave', this.onLeave);
      this.addEventListener('pointermove', this.onMove);

      this.onResize = function () { self.resize(); };
      window.addEventListener('resize', this.onResize);
    }

    tiltFrame() {
      if (this.reduced) return;
      var frame = this.slides[this.current] && this.slides[this.current].querySelector('.es-hero3d__frame');
      if (!frame) return;
      var rx = (-this.mouse.ty * 6).toFixed(2);
      var ry = (this.mouse.tx * 8).toFixed(2);
      frame.style.transform = 'rotateX(' + rx + 'deg) rotateY(' + ry + 'deg)';
    }

    intro() {
      var first = this.slides[0];
      if (!first) return;
      if (this.gsap) {
        var kids = first.querySelectorAll('[data-anim]');
        this.gsap.set(this.slides, { autoAlpha: 0 });
        this.gsap.set(first, { autoAlpha: 1 });
        this.gsap.fromTo(kids, { y: 28, autoAlpha: 0 },
          { y: 0, autoAlpha: 1, duration: 0.7, stagger: 0.09, ease: 'power3.out', delay: 0.1 });
      }
    }

    goTo(n) {
      if (!this.slides.length) return;
      n = (n % this.slides.length + this.slides.length) % this.slides.length;
      if (n === this.current) return;
      var cur = this.slides[this.current], nxt = this.slides[n];
      this.dots.forEach(function (d, i) { d.classList.toggle('is-active', i === n); });

      if (this.gsap) {
        var g = this.gsap;
        var kids = nxt.querySelectorAll('[data-anim]');
        var frame = nxt.querySelector('.es-hero3d__frame');
        g.killTweensOf([cur, nxt]);
        g.to(cur, { autoAlpha: 0, duration: 0.45, ease: 'power2.inOut',
          onComplete: function () { cur.classList.remove('is-active'); } });
        nxt.classList.add('is-active');
        g.fromTo(nxt, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.55, ease: 'power2.out' });
        g.fromTo(kids, { y: 26, autoAlpha: 0 },
          { y: 0, autoAlpha: 1, duration: 0.6, stagger: 0.08, ease: 'power3.out', delay: 0.08 });
        if (frame) g.fromTo(frame, { autoAlpha: 0, scale: 0.94, rotateY: -10 },
          { autoAlpha: 1, scale: 1, rotateY: 0, duration: 0.7, ease: 'power3.out' });
      } else {
        cur.classList.remove('is-active');
        nxt.classList.add('is-active');
      }
      this.current = n;
    }

    play() { this.pause(); var self = this; this.timer = setInterval(function () { self.goTo(self.current + 1); }, this.speed); }
    pause() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    restart() { if (this.autoplay) this.play(); }

    /* ---------- WebGL ---------- */
    initThree() {
      var THREE = window.THREE;
      if (!THREE) { this.classList.add('no-webgl'); return; }
      var renderer;
      try {
        renderer = new THREE.WebGLRenderer({ canvas: this.canvas, antialias: false, alpha: false, powerPreference: 'low-power' });
      } catch (e) { this.classList.add('no-webgl'); return; }
      this.renderer = renderer;
      renderer.setClearColor(new THREE.Color().fromArray(hexToRgb(this.dataset.bg)), 1);
      this.scene = new THREE.Scene();
      this.cam = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);

      this.u = {
        uTime: { value: 0 },
        uAspect: { value: 1 },
        uMouse: { value: new THREE.Vector2(0, 0) },
        uBg: { value: new THREE.Vector3().fromArray(hexToRgb(this.dataset.bg)) },
        uMid: { value: new THREE.Vector3().fromArray(hexToRgb(this.dataset.mid)) },
        uGlow1: { value: new THREE.Vector3().fromArray(hexToRgb(this.dataset.glow1)) },
        uGlow2: { value: new THREE.Vector3().fromArray(hexToRgb(this.dataset.glow2)) }
      };
      var auroraMat = new THREE.RawShaderMaterial({
        uniforms: this.u, vertexShader: AURORA_VERT, fragmentShader: AURORA_FRAG, depthTest: false, depthWrite: false
      });
      this.scene.add(new THREE.Mesh(new THREE.PlaneGeometry(2, 2), auroraMat));

      // partículas
      var count = Math.max(0, Math.min(220, parseInt(this.dataset.particles, 10) || 0));
      if (count > 0) {
        var pos = new Float32Array(count * 3), dep = new Float32Array(count), siz = new Float32Array(count), pha = new Float32Array(count);
        for (var i = 0; i < count; i++) {
          pos[i*3] = (i * 0.61803398875 % 1) * 2 - 1;        // distribución determinista
          pos[i*3+1] = (i * 0.7548776662 % 1) * 2 - 1;
          pos[i*3+2] = 0;
          dep[i] = (i % 7) / 7;
          siz[i] = 6 + (i % 5) * 5;
          pha[i] = (i * 1.37) % 6.283;
        }
        var g = new THREE.BufferGeometry();
        g.setAttribute('position', new THREE.BufferAttribute(pos, 3));
        g.setAttribute('aDepth', new THREE.BufferAttribute(dep, 1));
        g.setAttribute('aSize', new THREE.BufferAttribute(siz, 1));
        g.setAttribute('aPhase', new THREE.BufferAttribute(pha, 1));
        var pMat = new THREE.RawShaderMaterial({
          uniforms: { uTime: this.u.uTime, uMouse: this.u.uMouse, uTint: { value: new THREE.Vector3().fromArray(hexToRgb(this.dataset.ptint)) } },
          vertexShader: PT_VERT, fragmentShader: PT_FRAG,
          transparent: true, depthTest: false, depthWrite: false, blending: THREE.AdditiveBlending
        });
        this.points = new THREE.Points(g, pMat);
        this.points.renderOrder = 1;
        this.scene.add(this.points);
      }

      this.resize();
      this.running = true;
      var self = this, t0 = null;
      this.loop = function (ts) {
        if (!self.running) return;
        if (t0 === null) t0 = ts;
        self.u.uTime.value = (ts - t0) / 1000;
        self.mouse.x += (self.mouse.tx - self.mouse.x) * 0.05;
        self.mouse.y += (self.mouse.ty - self.mouse.y) * 0.05;
        self.u.uMouse.value.set(self.mouse.x, -self.mouse.y);
        renderer.render(self.scene, self.cam);
        self.raf = requestAnimationFrame(self.loop);
      };
      this.raf = requestAnimationFrame(this.loop);
    }

    resize() {
      if (!this.renderer) return;
      var w = this.clientWidth || 1, h = this.clientHeight || 1;
      var dpr = Math.min(window.devicePixelRatio || 1, 1.75);
      this.renderer.setPixelRatio(dpr);
      this.renderer.setSize(w, h, false);
      if (this.u) this.u.uAspect.value = w / h;
    }

    observe() {
      var self = this;
      if (!('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            if (self.renderer && !self.running) { self.running = true; self.raf = requestAnimationFrame(self.loop); }
            if (self.autoplay) self.play();
          } else {
            self.running = false; if (self.raf) cancelAnimationFrame(self.raf);
            self.pause();
          }
        });
      }, { threshold: 0.05 });
      this.io.observe(this);
    }

    cleanup() {
      this.pause();
      this.running = false;
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this.io) this.io.disconnect();
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('pointerenter', this.onEnter);
      this.removeEventListener('pointerleave', this.onLeave);
      this.removeEventListener('pointermove', this.onMove);
      window.removeEventListener('resize', this.onResize);
      if (this.renderer) { try { this.renderer.dispose(); } catch (e) {} this.renderer = null; }
    }
  }

  customElements.define('es-hero3d', EsHero3D);

  // Soporte editor de temas (Horizon / Online Store 2.0)
  document.addEventListener('shopify:section:select', function (e) {
    var el = e.target.querySelector('es-hero3d'); if (el && el.pause) el.pause();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var el = e.target.querySelector('es-hero3d'); if (el && el.autoplay && el.play) el.play();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
